"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.ExampleDataDialogueMobile = exports.ExampleDataDialogue = exports.ExampleDataOverlay = void 0;
var react_1 = __importDefault(require("react"));
var inversify_react_1 = require("inversify-react");
var MobileOnly_1 = require("Utils/MobileOnly");
var kaleidoscope_1 = require("@qwilr/kaleidoscope");
var icons_1 = require("@qwilr/kaleidoscope/icons");
var GradientBorderContainer_1 = require("Common/GradientContainer/GradientBorderContainer");
var BemBuilder_1 = __importDefault(require("@CommonFrontend/Utils/BemBuilder"));
var c = (0, BemBuilder_1.default)("example-data-dialogue");
var ExampleDataOverlay = function (_a) {
    var enabled = _a.enabled;
    if (!enabled)
        return null;
    return (react_1.default.createElement(react_1.default.Fragment, null,
        react_1.default.createElement("div", { className: "example-data-tint" }),
        react_1.default.createElement("div", { className: "example-data-opacity" })));
};
exports.ExampleDataOverlay = ExampleDataOverlay;
var ExampleDataDialogue = function (_a) {
    var enabled = _a.enabled;
    var isMobile = (0, inversify_react_1.useInjection)("isMobile");
    if (!enabled || isMobile())
        return null;
    return (react_1.default.createElement(GradientBorderContainer_1.GradientBorderContainer, { className: c(), borderColor: "rainbow" },
        react_1.default.createElement(GradientBorderContainer_1.GradientBorderContainer, { className: c("icon-container"), borderColor: "rainbow", isRound: true },
            react_1.default.createElement(icons_1.Analytics, null)),
        react_1.default.createElement(kaleidoscope_1.Text, { size: "s", strong: true },
            "There are no pages to report. Adjust report filters or ",
            react_1.default.createElement(kaleidoscope_1.Link, { href: "#/templates-gallery" }, "create pages"))));
};
exports.ExampleDataDialogue = ExampleDataDialogue;
var ExampleDataDialogueMobile = function (_a) {
    var enabled = _a.enabled;
    if (!enabled)
        return null;
    return (react_1.default.createElement(MobileOnly_1.MobileOnly, null,
        react_1.default.createElement(GradientBorderContainer_1.GradientBorderContainer, { className: c("mobile"), borderColor: "rainbow" },
            react_1.default.createElement("div", { className: c("mobile", "content") },
                react_1.default.createElement(kaleidoscope_1.Text, { size: "s", strong: true }, "Data insights will be displayed below as soon as you create your first page"))),
        react_1.default.createElement(kaleidoscope_1.Label, { className: c("mobile", "label"), size: "l" }, "SAMPLE DATA")));
};
exports.ExampleDataDialogueMobile = ExampleDataDialogueMobile;
